import { render, staticRenderFns } from "./Underage.vue?vue&type=template&id=12cca458&scoped=true"
import script from "./Underage.vue?vue&type=script&lang=js"
export * from "./Underage.vue?vue&type=script&lang=js"
import style0 from "./Underage.vue?vue&type=style&index=0&id=12cca458&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cca458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12cca458')) {
      api.createRecord('12cca458', component.options)
    } else {
      api.reload('12cca458', component.options)
    }
    module.hot.accept("./Underage.vue?vue&type=template&id=12cca458&scoped=true", function () {
      api.rerender('12cca458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/oauth/Underage.vue"
export default component.exports